import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getClimateActionQueryDocument } from "./climate-action.gql.ts";

export interface UseGetClimateActionProps {
  id?: string;
  enabled?: boolean;
  useKeepPreviousData?: boolean;
}

export const useGetClimateAction = ({ id, enabled = true, useKeepPreviousData = false }: UseGetClimateActionProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.climateActions.detail(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Climate action ID is required");
      }

      const client = createOperationClient("GetClimateAction");
      const data = await client.request(getClimateActionQueryDocument, { input: { id } });

      return data.climateAction;
    },
    enabled: enabled && !!id,
    placeholderData: useKeepPreviousData ? keepPreviousData : undefined,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  return {
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
    climateAction: queryResult.data ?? null,
  };
};
